import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactDatePicker from 'react-datepicker';
import { FieldArray } from 'formik';
import LinkButton from '../../../../ui-elements/signite-link-button/linkButton';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
export const OtherCertificatesForm = ({ handleChange, handleBlur, values, errors, touched }) => {
  const { setFieldValue } = useFormikContext();
  return (
    <div className="signite-form">
      <FieldArray name="otherCertificates">
        {({ remove, push }) => (
          <>
            {values.otherCertificates &&
              values.otherCertificates.length > 0 &&
              values.otherCertificates.map((otherCertificate, index) => (
                <>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="title">
                      <BSForm.Label>Title</BSForm.Label>
                      <BSForm.Control
                        name={`otherCertificates.${index}.title`}
                        value={otherCertificate.title}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(errors, touched, `otherCertificates.${index}.title`)}`}
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `otherCertificates.${index}.title`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="title">
                      <BSForm.Label>University/College Name</BSForm.Label>
                      <BSForm.Control
                        name={`otherCertificates.${index}.university`}
                        value={otherCertificate.university}
                        onChange={handleChange}
                      />
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="startDate">
                      <BSForm.Label>Start MM/YYYY</BSForm.Label>
                      <ReactDatePicker
                        name={`otherCertificates.${index}.startDate`}
                        selected={otherCertificate.startDate ? new Date(otherCertificate.startDate) : null}
                        onChange={(val) => {
                          setFieldValue(`otherCertificates.${index}.startDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `otherCertificates.${index}.startDate`
                        )}`}
                        dateFormat="MM/yyyy"
                        maxDate={new Date()}
                        showMonthYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `otherCertificates.${index}.startDate`)}
                      </span>
                    </BSForm.Group>
                  </Row>
                  <Row className="mb-3">
                    <BSForm.Group as={Col} controlId="blank">
                      <BSForm.Label>End Date MM/YYYY</BSForm.Label>
                      <ReactDatePicker
                        name={`otherCertificates.${index}.endDate`}
                        selected={otherCertificate.endDate ? new Date(otherCertificate.endDate) : null}
                        onChange={(val) => {
                          setFieldValue(`otherCertificates.${index}.endDate`, val, true);
                        }}
                        onBlur={handleBlur}
                        className={`form-control ${getErrorClass(
                          errors,
                          touched,
                          `otherCertificates.${index}.endDate`
                        )}`}
                        dateFormat="MM/yyyy"
                        maxDate={new Date()}
                        showMonthYearPicker
                      />
                      <span className="errorMessage">
                        {getErrorMessage(errors, touched, `otherCertificates.${index}.endDate`)}
                      </span>
                    </BSForm.Group>
                    <BSForm.Group
                      as={Col}
                      controlId="removeCol"
                      className="d-flex justify-content-center align-items-center"
                    >
                      <LinkButton onClick={() => remove(index)} icon={faMinusCircle}></LinkButton>
                    </BSForm.Group>
                    <BSForm.Group as={Col} controlId="blank"></BSForm.Group>
                  </Row>
                </>
              ))}
            <Row className="mb-3">
              <Col>
                <LinkButton
                  label="Add Certificate"
                  onClick={() =>
                    push({
                      title: '',
                      university: '',
                      startDate: '',
                      endDate: '',
                    })
                  }
                ></LinkButton>
              </Col>
            </Row>
          </>
        )}
      </FieldArray>
    </div>
  );
};
